import React from 'react'

import styled from '@emotion/styled'
import { grayBorder, text, black03 } from '../../../_style';

const Container = styled.div`
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid ${grayBorder};
  dl {
    display: flex;
    font-feature-settings: "palt";
    dt, dd {
      ${text('14px', 22 / 14)}
    }
    & + dl {
      padding-top: 20px;
    }
    dt {
      min-width: 74px;
      margin-right: 9px;
    }
    dd {
      color: ${black03};
    }
  }
`

export default class DetailMainBody extends React.Component {
  render() {
    return(
      <Container>
        {this.props.children}
      </Container>
    )
  }
}
